export const MIXPANEL_PROPERTY_TYPE = {
	Super: 'superProperties',
	User: 'userProperties',
	Event: 'eventProperties',
};

export const MIXPANEL_PROPERTY_SOURCE = {
	Client: 'client',
	Axis: 'axis',
};

export const MIXPANEL_EVENT = {
	SubscribePaymentPage: 'subscribe_payment_page',
	SubscribePaymentPagePayNow: 'subscribe_payment_page_paynow',
};

export const MIXPANEL_VARIABLES = {
    SsoID: 'user.userId',
	UniqueUserId: 'uniqueUserId',
};

export const isMixpanelEnabled = () => {
    return typeof process.env.ADYEN_MIXPANEL_TOKEN !== 'undefined';
};

export const isEmptyObject = obj => {
	return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const getPrefixSSOID = (ssoID) => {
	return `mewatch-${ssoID}`;
}